import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './Shared/layout/layout.component';
import { LayoutDashboardComponent } from './Shared/layout-dashboard/layout-dashboard.component';

import { ipComponent } from './Component/Ip/ipComponent';
import { AlwaysAuthGuard } from './Common/AlwaysAuthGuard';
import { HowItWorksComponent } from './Component/how-it-works/how-it-works.component';

const routing: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: '', component: LayoutDashboardComponent, children: [
      { path: 'quote-history', canActivate: [AlwaysAuthGuard], loadChildren: './Component/quote-history/quotehistory.module#QuoteHistoryModule' },
      { path: 'quote-history/:id', canActivate: [AlwaysAuthGuard], loadChildren: './Component/quote-history/quotehistory.module#QuoteHistoryModule' },      
      { path: 'login', loadChildren: './Component/Login/Login.module#LoginModule' },
      { path: 'login/:id', loadChildren: './Component/Login/Login.module#LoginModule' },
      // { path: 'register', loadChildren: './Component/Registration/Registration.module#RegistrationModule' },
      { path: 'terms-condition', loadChildren: './Component/terms-condition/TermsCondition.module#TermsConditionModule' },
      { path: 'privacy-policy', loadChildren: './Component/privacy-policy/PrivacyPolicy.module#PrivacyPolicyModule' },
      { path: 'faq', loadChildren: './Component/faq/faq.module#FaqModule' },
      { path: 'quote-accept-reject', loadChildren: './Component/QuoteAcceptReject/QuoteAcceptReject.module#QuoteAcceptRejectModule' },
      { path: 'about-us', loadChildren: './Component/about-us/about-us.module#AboutUsModule' },
      { path: 'manage-account', loadChildren: './Component/manage-account/manage-account.module#ManageAccountModule' },
      { path: 'device-recieve', loadChildren: './Component/device-recieve/device-recieve.module#DeviceRecieveModule' },
      {
        path: 'delete-account', loadChildren: './Component/delete-account/delete-account.module#DeleteAccountModule',
      },
    ]
  },
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '', component: LayoutComponent, children: [

      { path: 'landing', loadChildren: './Component/Landing/Landing.module#LandingModule' },
      // { path: 'login', loadChildren: './Component/Login/Login.module#LoginModule' },      
      // { path: 'home', loadChildren: './Component/home/home.module#HomeModule' },
      { path: 'recycle', loadChildren: './Component/RecycleDevice/RecycleDevice.module#RecycleDeviceModule' },
      { path: 'trade-in', loadChildren: './Component/FOH/foh.module#FOHModule' },
      { path: 'inspection', loadChildren: './Component/inspection/inspection.module#InspectionModule' },
      { path: 'diagnostics', loadChildren: './Component/Diagnostic/diagnostic.module#DiagnosticModule' },
      { path: 'shipping-option', loadChildren: './Component/shipping/shipping.module#ShippingModule' },
     

      //auth guard
      { path: 'dashboard', canActivate: [AlwaysAuthGuard], loadChildren: './Component/Dashboard/Dashboard.module#DashboardModule' },
      { path: 'change-password', canActivate: [AlwaysAuthGuard], loadChildren: './Component/change-password/change-password.module#ChangePasswordModule' },
      // { path: 'quote-history', canActivate: [AlwaysAuthGuard], loadChildren: './Component/quote-history/quotehistory.module#QuoteHistoryModule' },

      { path: 'contact-us', loadChildren: './Component/contact-us/contact-us.module#ContactUsModule' },
      { path: 'soon-again', loadChildren: './Component/soonagain/soonagain.module#SoonagainModule' },
      {  path: 'how-it-works',loadChildren: './Component/how-it-works/how-it-works.module#HowItWorksModule'}
  
    ]
  },
  // {
  //   path: '', component: LayoutLoginComponent, children: [
  //     { path: 'login', loadChildren: './Component/Login/Login.module#LoginModule' },
  //    ]
  // },
  // {
  //   path: '', component: LayoutComponent, canActivate: [AlwaysAuthGuard], children: [
  //     { path: 'dashboard', loadChildren: './Component/Dashboard/Dashboard.module#DashboardModule' },
  //     { path: 'change-password', loadChildren: './Component/change-password/change-password.module#ChangePasswordModule' },
  //     { path: 'quote-history', loadChildren: './Component/quote-history/quotehistory.module#QuoteHistoryModule' },
  //   ]
  // },
  {
    path: 'order-print', loadChildren: './Component/Wrapper/wrapperfoh.module#WrapperfohModule',
  },
 
  // {  path: 'how-it-works',component:HowItWorksComponent}
 
  // ,
  // { path: '**', redirectTo: 'home', pathMatch: 'full' }

];

export const routModule: ModuleWithProviders = RouterModule.forRoot(routing);


